export const TRANSLATION_NL = {
    APPLICATION: {
        title: 'Project Intake Tool',
        welcome: 'Welkom bij de Project Intake Tool'
    },
    YES_OR_NO: {
        yes: 'Ja',
        no: 'Nee'
    },
    MENU: {
        labels: {
            projects: 'Nieuwe projecten',
            projects_all: 'Alle projecten'
        }
    },
    COUNTRY: { // see https://nl.wikipedia.org/wiki/ISO_3166-1 (note that a few, obscure, countries have been omitted)
        AF:'Afghanistan',
        AL:'Albanië',
        DZ:'Algerije',
        VI:'Amerikaanse Maagdeneilanden',
        AS:'Amerikaans-Samoa',
        AD:'Andorra',
        AO:'Angola',
        AI:'Anguilla',
        AQ:'Antarctica',
        AG:'Antigua en Barbuda',
        AR:'Argentinië',
        AM:'Armenië',
        AW:'Aruba',
        AU:'Australië',
        AZ:'Azerbeidzjan',
        BS: "Bahama's",
        BH:'Bahrein',
        BD:'Bangladesh',
        BB:'Barbados',
        BE:'België',
        BZ:'Belize',
        BJ:'Benin',
        BM:'Bermuda',
        BT:'Bhutan',
        BO:'Bolivia',
        BA:'Bosnië en Herzegovina',
        BW:'Botswana',
        BV:'Bouvet',
        BR:'Brazilië',
        VG:'Britse Maagdeneilanden',
        BN:'Brunei',
        BG:'Bulgarije',
        BF:'Burkina Faso',
        BI:'Burundi',
        KH:'Cambodja',
        CA:'Canada',
        BQ:'Caribisch Nederland',
        CF:'Centraal-Afrikaanse Republiek',
        CL:'Chili',
        CN:'China',
        CX:'Christmaseiland',
        CC:'Cocoseilanden',
        CO:'Colombia',
        KM:'Comoren',
        CG:'Congo-Brazzaville',
        CD:'Congo-Kinshasa',
        CK:'Cookeilanden',
        CR:'Costa Rica',
        CU:'Cuba',
        CW:'Curaçao',
        CY:'Cyprus',
        DK:'Denemarken',
        DJ:'Djibouti',
        DM:'Dominica',
        DO:'Dominicaanse Republiek',
        DE:'Duitsland',
        EC:'Ecuador',
        EG:'Egypte',
        SV:'El Salvador',
        GQ:'Equatoriaal-Guinea',
        ER:'Eritrea',
        EE:'Estland',
        ET:'Ethiopië',
        FO:'Faeröer',
        FK:'Falklandeilanden',
        FJ:'Fiji',
        PH:'Filipijnen',
        FI:'Finland',
        FR:'Frankrijk',
        GF:'Frans-Guyana',
        PF:'Frans-Polynesië',
        GA:'Gabon',
        GM:'Gambia',
        GE:'Georgië',
        GH:'Ghana',
        GI:'Gibraltar',
        GD:'Grenada',
        GR:'Griekenland',
        GL:'Groenland',
        GP:'Guadeloupe',
        GU:'Guam',
        GT:'Guatemala',
        GG:'Guernsey',
        GN:'Guinee',
        GW:'Guinee-Bissau',
        GY:'Guyana',
        HT:'Haïti',
        HN:'Honduras',
        HU:'Hongarije',
        HK:'Hongkong',
        IE:'Ierland',
        IS:'IJsland',
        IN:'India',
        ID:'Indonesië',
        IQ:'Irak',
        IR:'Iran',
        IL:'Israël',
        IT:'Italië',
        CI:'Ivoorkust',
        JM:'Jamaica',
        JP:'Japan',
        YE:'Jemen',
        JE:'Jersey',
        JO:'Jordanië',
        KY:'Kaaimaneilanden',
        CV:'Kaapverdië',
        CM:'Kameroen',
        KZ:'Kazachstan',
        KE:'Kenia',
        KG:'Kirgizië',
        KI:'Kiribati',
        XK:'Kosovo',
        KW:'Koeweit',
        HR:'Kroatië',
        LA:'Laos',
        LS:'Lesotho',
        LV:'Letland',
        LB:'Libanon',
        LR:'Liberia',
        LY:'Libië',
        LI:'Liechtenstein',
        LT:'Litouwen',
        LU:'Luxemburg',
        MO:'Macau',
        MG:'Madagaskar',
        MW:'Malawi',
        MV:'Malediven',
        MY:'Maleisië',
        ML:'Mali',
        MT:'Malta',
        IM:'Man',
        MA:'Marokko',
        MH:'Marshalleilanden',
        MQ:'Martinique',
        MR:'Mauritanië',
        MU:'Mauritius',
        YT:'Mayotte',
        MX:'Mexico',
        FM:'Micronesië',
        MD:'Moldavië',
        MC:'Monaco',
        MN:'Mongolië',
        ME:'Montenegro',
        MS:'Montserrat',
        MZ:'Mozambique',
        MM:'Myanmar',
        NA:'Namibië',
        NR:'Nauru',
        NL:'Nederland',
        NP:'Nepal',
        NI:'Nicaragua',
        NC:'Nieuw-Caledonië',
        NZ:'Nieuw-Zeeland',
        NE:'Niger',
        NG:'Nigeria',
        NU:'Niue',
        MK:'Noord-Macedonië',
        NO:'Noorwegen',
        NF:'Norfolk',
        UG:'Oeganda',
        UA:'Oekraïne',
        UZ:'Oezbekistan',
        OM:'Oman',
        AT:'Oostenrijk',
        TL:'Oost-Timor',
        PK:'Pakistan',
        PW:'Palau',
        PS:'Palestina',
        PA:'Panama',
        PG:'Papoea-Nieuw-Guinea',
        PY:'Paraguay',
        PE:'Peru',
        PN:'Pitcairneilanden',
        PL:'Polen',
        PT:'Portugal',
        PR:'Rico Puerto Rico',
        QA:'Qatar',
        RE:'Réunion',
        RO:'Roemenië',
        RU:'Rusland',
        RW:'Rwanda',
        BL:'Saint-Barthélemy',
        KN:'Saint Kitts en Nevis',
        LC:'Saint Lucia',
        PM:'Saint-Pierre en Miquelon',
        SB:'Salomonseilanden',
        WS:'Samoa',
        SM:'San Marino',
        SA:'Saoedi-Arabië',
        SN:'Senegal',
        RS:'Servië',
        SC:'Seychellen',
        SL:'Sierra Leone',
        SG:'Singapore',
        MF:'Saint-Martin',
        SX:'Sint Maarten',
        SI:'Slovenië',
        SK:'Slowakije',
        SD:'Soedan',
        SO:'Somalië',
        ES:'Spanje',
        LK:'Sri Lanka',
        SR:'Suriname',
        SZ:'Swaziland',
        SY:'Syrië',
        TJ:'Tadzjikistan',
        TW:'Taiwan',
        TZ:'Tanzania',
        TH:'Thailand',
        TG:'Togo',
        TK:'Tokelau',
        TO:'Tonga',
        TT:'Trinidad en Tobago',
        TD:'Tsjaad',
        CZ:'Tsjechië',
        TN:'Tunesië',
        TR:'Turkije',
        TM:'Turkmenistan',
        TV:'Tuvalu',
        UY:'Uruguay',
        VU:'Vanuatu',
        VA:'Vaticaanstad',
        VE:'Venezuela',
        AE:'Verenigde Arabische Emiraten',
        US:'Verenigde Staten',
        GB:'Verenigd Koninkrijk',
        VN:'Vietnam',
        WF:'Wallis en Futuna',
        EH:'Westelijke Sahara',
        BY:'Wit-Rusland',
        ZM:'Zambia',
        ZW:'Zimbabwe',
        ZA:'Zuid-Afrika',
        KR:'Zuid-Korea',
        SS:'Zuid-Soedan',
        SE:'Zweden',
        CH:'Zwitserland'
    },
    BUTTON: {
        logout: 'Uitloggen',
        cancel: 'Annuleren',
        save: 'Opslaan',
        close: 'Sluiten',
        archive: 'Verwijderen',
        filters: 'Filteren',
        dismiss: 'Verbergen',
        close_example: 'Voorbeeld sluiten'
    },
    PROJECT_STATUS: {
        initial: 'In behandeling',
        quickscan_saved: 'Quickscan definitief',
        mandating: 'In goedkeuringsflow',
        mandating_failed: '{{ tisLabelShort }} afgekeurd',
        mandating_succeeded: '{{ tisLabelShort }} goedgekeurd',
        in_execution: 'In uitvoering',
        archived: 'Verwijderd',
        on_hold: 'On hold',
        closed: 'Afgesloten'
    },
    PROJECT_MENU: {
        download: 'Download PDF'
    },
    PAGE_NO_ACCESS: {
        title: 'Geen toegang',
        message: 'U heeft geen toegang tot deze applicatie.'
    },
    PAGE_ERROR: {
        title: 'Fout tijdens authenticatie-proces',
        message: 'Er is iets fout gegaan bij het authenticeren binnen de applicatie. Probeer het op een later moment nogmaals. Indien het probleem blijft optreden, neem dan contact op met uw beheerder.'
    },
    PAGE_DOCUMENTS: {
        table: {
            column: {
                fileName: 'Bijlage',
                modifiedBy: 'Door',
                modifiedAt: 'Datum'
            }
        },
        no_documents: {
            message: 'Er zijn geen documenten gevonden'
        }
    },
    PAGE_PROJECTEN: {
        title: 'Nieuwe projecten',
        title_all: 'Alle projecten',
        new_project: 'Nieuw project',
        generate_csv: 'CSV-export',
        filter: {
            status: {
                placeholder: 'Status'
            },
            classification: {
                placeholder: 'Classificatie'
            },
            companies: {
                placeholder: 'Werkmaatschappij'
            },
            constructionCosts: {
                placeholder: 'Verwachte aanneemsom'
            }
        },
        table: {
            column: {
                name: 'Project',
                modifiedAt: 'Laatste wijziging',
                company: 'Werkmaatschappij',
                client: 'Opdrachtgever',
                construction_costs: 'Verwachte aanneemsom',
                tender_costs: 'Tenderkosten',
                height_above: 'Hoogte gebouw',
                height_under: 'Onder maaiveld',
                bvo: 'BVO',
                flag: '🏴',
                classification: 'Classificatie',
                classification_tooltip: 'De eerste waarde is de classificatie op basis van de initiële Quickscan. De tweede waarde is de huidige waarde op basis van de bijgewerkte Quickscan',
                tender_date: 'Aanbiedings datum'
            }
        },
        form: {
            name: 'Projectnaam',
            address: 'Adres',
            city: 'Plaatsnaam',
            country: 'Land',
            companyName: 'Werkmaatschappij'
        },
        placeholder: {
            name: 'Naam van je project',
            address: 'Adres',
            city: 'Plaats',
            country: 'Land',
            companyName: 'Selecteer werkmaatschappij'
        },
        no_projects: {
            message_title: 'Er zijn geen projecten gevonden',
            search_title: 'Er zijn geen projecten gevonden op basis van de zoekcriteria.'
        }
    },
    PAGE_PROJECT_DETAILS: {
        title: 'Projectgegevens',
        general_title: 'Algemene gegevens',
        contract_title: 'Contract gegevens',
        processing_thumbnail: 'Bezig met het verwerken van de afbeelding.',
        title_project_info: "Projectgegevens",
        title_client: "Opdrachtgever / Afnemer / Ontwikkelaar",
        title_financial: "Financieel & Contract",
        title_planning: "Planning / Bouwtijd",
        title_team: "Bouwteam",
        title_design_team: "Ontwerpende partij",
        address: 'Adres',
        city: 'Plaatsnaam',
        country: 'Land',
        project_info: {
            units: "Wooneenheden (aantal)",
            costs: "Verwachte aanneemsom",
            space: "Commerciële ruimte (m2)",
            bvo: "BVO (m2)",
            work_type: "Werksoort",
            function: "Gebruiksfunctie (hoofd)",
            sub_function: "Sub-gebruiksfunctie",
            height_above: "Hoogte gebouw",
            height_under: "Bouwlagen onder maaiveld",
            tender_date: "Aanbiedingsdatum",
        },
        client: {
            client: "Opdrachtgever",
            client_type: "Type opdrachtgever",
            owner: "Ontwikkelaar",
            design_owner: "Ontwerpverantwoordelijkheid",
            acquisition_type: "Wijze van verwerving",
            credit_score: "Kredietscore",
            alt_client: "Afnemer indien anders"
        },
        financial: {
            contract_scope: "Contractscope",
            realisation_form: "Algemene voorwaarden",
            criteria: "Gunningcriteria (EMV)",
            tender_date: "Aanbiedingsdatum",
            tender_costs: "Tenderkosten"
        },
        planning: {
            start_date: "Startdatum werk",
            end_date: "Einddatum werk",
            project_duration: "Duur project (in maanden)",
            number_of_phases: "Aantal fasen uitvoering",
            nuts_capacity_problem: "Nutsvoorzieningen capaciteitenprobleem",
            natura_2000_area: "Natura 2000 gebied",
            nitrogen_complicity: "Voldoet aan aerius-berekening stikstof"
        },
        team: {
            legal_form: "Rechtsvorm samenwerking",
            parties: "Samenwerking met"
        },
        design_team: {
            architect: "Architect",
            constructor: "Constructeur"
        },
        contractType: {
            traditional: 'Traditioneel',
            integrated: 'Geïntegreerd',
            other: 'Overig'
        },
        termsAndConditions: {
            UAV: 'UAV',
            'UAV-GC': 'UAV-GC',
            DNR: 'DNR',
            other: 'Overig'
        },
        start_project: 'Start project',
        project_name: 'Projectnaam',
        owner: 'Verantwoordelijk',
        status: 'Status',
        classification: 'Classificatie',
        location: 'Locatie',
        project_number: 'Projectnummer',
        message_updated: 'De wijzigingen voor de projectgegevens zijn succesvol opgeslagen!',
        message_moved: 'De project verantwoordelijke en de wijzigingen voor de projectgegevens zijn succesvol opgeslagen!',
        error_message: 'Er ging iets fout bij het opslaan van het project. Probeer het later nog eens.',
        tender_manager: 'Tendermanager',
        project_risk_manager: 'Projectrisicomanager'
    },
    PAGE_LOGOUT: {
        title: 'U bent uitgelogd',
        message: 'U bent succesvol uitgelogd uit de applicatie. U wordt doorgeleid naar de loginpagina'
    },
    DATE: {
        long: 'dd-MM-yyyy \'om\' HH:mm',
        short: 'dd-MM-yyyy'
    },
    PDF: {
        modal: {
            title: 'PDF samenstellen',
            download: 'Samenstellen en downloaden',
            project_details: 'Projectgegevens',
            quickscan_questions: 'Quickscan',
            tis_quickscan_questions: '{{ tisLabelShort }} quickscan',
            tis: '{{ tisLabelShort }} aanvullende vragen',
            risk_rainbow: 'Risico Dashboard',
            risk_rainbow_client: 'Risico Dashboard - opdrachtgever',
            risks_opportunities: 'Risicodossier',
            filters_complete: 'Compleet dossier',
            filters_only: 'Gefilterd dossier',
            risks_opportunities_client: 'Risicodossier - opdrachtgever',
            risks_opportunities_list: 'Risico’s opdrachtgever',
            forecast_end_result_list: 'Prognose eindresultaat',
            mandating_flow: 'Mandateringsflow',
            proposals: 'Inclusief voorstellen'
        },
        PDF_TYPE_DEFAULT: 'Standaard PDF',
        PDF_TYPE_CLIENT_LIST: 'Risico’s opdrachtgever',
        PDF_TYPE_FORECAST_END_RESULT_LIST: 'Prognose eindresultaat'
    },
    ERRORS: {
        no_items_found_for_type: 'Voor dit type zijn geen items gevonden.',
        no_items_added_for_type: 'Voor dit type zijn geen items toegevoegd.',
        filesize_too_high: 'Het bestand is te groot, gelieve een bestand te uploaden dat minder is dan 10MB',
        risks: {
            min_higher_than_max: 'De ingevulde best case is hoger dan de worst case.',
            min_higher_than_best_guess: 'De ingevulde best case is hoger dan de best guess.',
            best_guess_higher_than_max: 'De ingevulde best guess is hoger dan de worst case.',
            min_max_but_no_best_guess: 'Er is geen best guess ingevuld, terwijl er wel een worst case en best case zijn ingevuld.'
        },
        opportunities: {
            min_higher_than_max: 'De ingevulde worst case is hoger dan de best case.',
            min_higher_than_best_guess: 'De ingevulde worst case is hoger dan de best guess.',
            best_guess_higher_than_max: 'De ingevulde best guess is hoger dan de best case.',
            min_max_but_no_best_guess: 'Er is geen best guess ingevuld, terwijl er wel een worst case en best case zijn ingevuld.'
        },
        tasks: {
            min_higher_than_max: 'De ingevulde worst case is hoger dan de best case.',
            min_higher_than_best_guess: 'De ingevulde worst case is hoger dan de best guess.',
            best_guess_higher_than_max: 'De ingevulde best guess is hoger dan de best case.',
            min_max_but_no_best_guess: 'Er is geen best guess ingevuld, terwijl er wel een worst case en best case zijn ingevuld.'
        },
        too_many_euros: 'Het ingevulde bedrag is te hoog.',
        project_not_found: 'Het project kon niet gevonden worden.',
        csv_generation_failed: 'Er is iets fout gegaan bij het genereren van de CSV-export.',
        pdf_download_failed: 'Er is iets fout gegaan bij het downloaden van de PDF.',
        projects_not_updated: 'De lijst met projecten kon niet worden opgehaald.',
        documents_not_updated: 'De lijst met documenten kon niet worden opgehaald.',
        project_not_created: 'Het project kon niet worden aangemaakt.',
        library_not_updated: 'De bibliotheek kon niet worden bijgewerkt.',
        library_not_retrieved: 'De bibliotheek kon niet worden opgehaald.',
        quickscans_not_updated: 'De lijst met quickscans kon niet worden opgehaald.',
        quickscan_not_published: 'De quickscan kon niet worden gepubliceerd.',
        quickscan_not_updated: 'De quickscan kon niet worden bijgewerkt.',
        quickscan_not_retrieved: 'De quickscan kon niet worden opgehaald.',
        quickscan_not_calculated: 'De classificatie voor de quickscan kon niet worden bepaald.',
        quickscan_result_not_retrieved: 'Het resultaat van de quickscan kon niet worden opgehaald.',
        tis_not_updated: 'De lijst met {{ tisLabelShort }}-definities kon niet worden opgehaald.',
        tis_not_published: 'De {{ tisLabelShort }}-definitie kon niet worden gepubliceerd.',
        tis_not_retrieved: 'De {{ tisLabelShort }}-definitie kon niet worden opgehaald.',
        project_not_updated: 'Het project kon niet worden opgeslagen.',
        project_mandate_details_not_retrieved: 'De mandateringsstatus voor het project kon niet worden bepaald.',
        project_mandate_details_nok: 'De mandatering kon helaas niet gestart worden. Probeer het later nogmaals.',
        start_mandate_failed: 'Het starten van de mandatering is mislukt.',
        project_to_execution_nok: 'Het is helaas niet gelukt om de projectstatus aan te passen. Probeer het later nogmaals.',
        project_to_closed_nok: 'Het is helaas niet gelukt om het project af te sluiten. Probeer het later nogmaals.',
        project_to_archived_nok: 'Het is helaas niet gelukt om het project te verwijderen. Probeer het later nogmaals.',
        project_sharing_failed: 'Het is helaas niet gelukt om de instellingen van het project rondom het delen op te slaan. Probeer het later nogmaals.',
        tender_managers_not_retrieved: 'Het is helaas niet gelukt om de lijst met tendermanagers op te halen. Probeer het later nogmaals.',
        tender_manager_not_deleted: 'Het is helaas niet gelukt om de tendermanager te verwijderen. Probeer het later nogmaals.',
        tender_manager_not_added: 'Het is helaas niet gelukt om de tendermanager toe te voegen. Probeer het later nogmaals.',
        tender_manager_not_modified: 'Het is helaas niet gelukt om de tendermanager bij te werken. Probeer het later nogmaals.',
        tender_manager_already_exists: 'Er is al een tendermanager met hetzelfde e-mailadres toegevoegd.',
        companies_not_retrieved: 'Het is helaas niet gelukt om de lijst met werkmaatschappijen op te halen. Probeer het later nogmaals.',
        company_not_deleted: 'Het is helaas niet gelukt om de werkmaatschappij te verwijderen. Probeer het later nogmaals.',
        company_not_add: 'Het is helaas niet gelukt om de werkmaatschappij toe te voegen. Probeer het later nogmaals.',
        company_not_modified: 'Het is helaas niet gelukt om de werkmaatschappij bij te werken. Probeer het later nogmaals.',
        company_already_exists: 'Er is al een werkmaatschappij met dezelfde naam toegevoegd.',
        types_not_retrieved: 'Het is helaas niet gelukt om de lijst met bedrijfstypes op te halen. Probeer het later nogmaals.',
        type_not_deleted: 'Het is helaas niet gelukt om het bedrijfstype te verwijderen. Probeer het later nogmaals.',
        type_not_added: 'Het is helaas niet gelukt om het bedrijfstype toe te voegen.',
        type_not_modified: 'Het is helaas niet gelukt om het bedrijfstype bij te werken. Probeer het later nogmaals.',
        type_already_exists: 'Er is al een bedrijfstype met dezelfde naam toegevoegd.',
        library_type: {
            risks: {
                not_updated: 'De risico\'s konden niet worden opgeslagen.',
                not_deleted: 'Het risico kon niet worden verwijderd.'
            },
            opportunities: {
                not_updated: 'De kans kon niet worden opgeslagen.',
                not_deleted: 'De kans kon niet worden verwijderd.'
            },
            tasks: {
                not_updated: 'De taak kon niet worden opgeslagen.',
                not_deleted: 'De taak kon niet worden verwijderd.'
            }
        },
        error_code: {
            generic: 'Er is een onverwachte fout opgetreden.',
            quickscan_not_published: 'Er is nog geen quickscan gepubliceerd. Neem contact op met de riskmanager.',
            tis_not_published: 'Er is nog geen TIS gepubliceerd. Neem contact op met de riskmanager.',
            cannot_mandate_project: 'Dit project kan niet gemandateerd worden op dit moment.',
            flow_not_started: 'De flow kon niet worden verstuurd richting Power Automate',
            cannot_execute_project: 'Dit project kan niet verplaatst worden naar de status: In uitvoer.',
            cannot_delete_tender_manager: 'De tendermanager kan niet worden verwijderd, aangezien deze nog actieve projecten heeft.',
            cannot_delete_company: 'De werkmaatschappij kan niet worden verwijderd, aangezien deze nog actieve tender managers en/of projecten heeft.',
            type_in_use: 'Dit bedrijfstype kan niet meer worden verwijderd, aangezien deze al in gebruik is.',
            project_members_not_unique: 'De lijst met projectdeelnemers bevat één of meerdere dubbele e-mailadressen',
            library_entry_used_in_answers: 'Dit bibliotheekitem wordt reeds gerefereerd vanuit een quickscan.',
            risk_used_in_project: 'Bibliotheekitem is in gebruik en kan niet verwijderd worden.'
        }
    },
    DISABLED: {
        not_owner: 'Alleen de eigenaar van dit project kan deze actie uitvoeren.',
        not_item_owner: 'Alleen de eigenaar van dit voorstel kan deze actie uitvoeren.',
        not_tender_manager: 'Alleen tendermanagers kunnen deze actie uitvoeren.',
        no_edit_rights: 'U heeft alleen leesrechten op dit gedeelte van het project.',
        quickscan_finalized: 'De quickscan is reeds definitief.',
        form_invalid: 'Oeps, het formulier bevat onjuiste velden. Wilt u dit controleren?',
        in_mandate: 'Deze actie kan niet worden uitgevoerd aangezien de mandatering is gestart.',
        no_on_hold_rights: 'Alleen tendermanagers en/of de eigenaar van het project kunnen deze actie uitvoeren.',
        project_on_hold: 'Het project is on hold en kan niet aangepast worden.',
        project_closed: 'Het project is afgesloten en kan niet aangepast worden.'
    },
    NGSELECT: {
        add: 'Voeg toe',
        clear: 'Leegmaken'
    },
    NAV: {
        project: {
            all: 'Alle projecten'
        }
    },
    CLASSIFICATION: {
        color: {
            initial: 'N.n.b.',
            red: 'H',
            green: 'L',
            orange: 'G'
        },
        initial: 'N.n.b.',
        red: 'Hoog',
        green: 'Laag',
        orange: 'Gemiddeld'
    },
    FILTER_CONSTRUCTION_COSTS: {
        less_than_10m: '< 10.000K euro',
        between_10m_and_25m: '10.000K - 24.999K euro',
        between_25m_and_50m: '25.000K - 50.000K euro',
        greater_than_50m: '> 50.000K euro'
    },
    A11Y: {
        go_to_content: 'Ga naar inhoud'
    }
};
